/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui-folders-default-roles{display:flex;flex-direction:column}.ui-folders-default-roles .mat-list{width:100%;max-width:17em}.ui-folders-default-roles .mat-list-item-content{justify-content:space-between}.ui-folders-default-roles .role-label{font-weight:400;font-size:14px;opacity:.9}.ui-folders-default-roles .role-label.is-created{opacity:1;font-weight:600}"];
export { styles as styles };
